import { useMemo, useEffect, useState } from 'react';
import { debounce } from 'lodash';

export const useDebouncedState = <T>(value: T, interval = 50) => {
    const [state, setState] = useState(value);

    const debounceSetState = useMemo(
        () =>
            debounce((state) => setState(state), interval, {
                maxWait: interval * 2,
                leading: false,
                trailing: true,
            }),
        [setState, interval],
    );

    useEffect(() => {
        debounceSetState(value);
    }, [debounceSetState, value]);

    useEffect(() => debounceSetState.cancel, [debounceSetState]);

    return state;
};
